<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="from-wrap" v-show="!introductionShow">
          <div class="set-wrap">
            <div class="set-info">
              <div class="t">昵称</div>
              <div class="des">
                <input type="text" v-model="nickname" maxlength="16" /><span class="icon"></span>
              </div>
            </div>
            <div class="set-ts" v-if="Number(userInfo.account.is_nickname) === 1">昵称审核中</div>
            <div class="set-ts" v-if="Number(userInfo.account.is_nickname) === 2">昵称审核失败，请重新审核</div>
            
          </div>
          <div class="set-wrap">
            <div class="set-info">
              <div class="t">性别</div>
              <div class="des">
                <span
                  @click="sex = '1'"
                  :class="{ sex: true, active: sex === '1' }"
                  >男</span
                >
                <span
                  @click="sex = '2'"
                  :class="{ sex: true, active: sex === '2' }"
                  >女</span
                >
                <span
                  @click="sex = '3'"
                  :class="{ sex: true, active: sex === '3' }"
                  >未设定</span
                >
              </div>
            </div>
          </div>
          <div class="set-wrap" v-show="false">
            <div class="set-info" @click="introductionShow = true">
              <div class="t">简介</div>
              <div class="des">
                <div class="text">{{ signature }}</div>
                <span class="icon"></span>
              </div>
            </div>
          </div>

          <div class="set-wrap">
            <div class="set-title">头像</div>
            <div class="set-img">
              <div
                class="img-box"
                @click="$router.push('/user/profile/uploadhead')"
              >
                <div
                  class="img"
                  :style="{ 'background-image': `url(${avatar})` }"
                  v-show="avatar"
                ></div>
                <div class="noImg" v-show="!avatar"></div>
              </div>
            </div>
          </div>
          
          <div class="set-btn2">
            <van-button @click="submit()" :loading="isLoading" :disabled="isLoading" loading-text="保 存"  >保 存</van-button>
          </div>

        </div>
        
        <div class="introduction-wrap" v-show="introductionShow">
          <div class="in-head">
            <div class="btn black" @click="introductionShow = false">取消</div>
            <div class="btn red" @click="signatureFrom()">保存</div>
          </div>
          <div class="in-content">
            <van-field
              v-model="signature"
              rows="5"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="介绍一下自己，让大家都认识你～"
              show-word-limit
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Toast, Dialog, Field, Button } from "vant";

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Button);

export default {
  name: "user-profile",
  data() {
    return {
      nickname: "",
      sex: "",
      signature: "",
      avatar: "",
      introductionShow: false,
      isLoading:false,

    };
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;

    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
    });
    this.getUserInfo({
      success: (res) => {
        // console.log(res)
        toastLoading.clear();
        if (res.status == 1) {
          // this.nickname = res.user.nickname;

          if(res.user.chknickname){
            this.nickname = res.user.chknickname;
          } else {
            this.nickname = res.user.nickname;
          }

          this.sex = res.user.sex;
          this.signature = res.user.signature;
          this.avatar = res.user.avatar;
          
        } else {
          Toast(res.message);
        }
      },
    });
  },

  methods: {
    ...mapActions({
      getUserInfo: "user/getUserInfo",
      updateUserInfo: "user/updateUserInfo",
      updateUserInfoSignature: "user/updateUserInfoSignature",

      
    }),

    submit() {
      let that = this;
      let nickname = this.nickname;
      let sex = this.sex;

      if (nickname.match(/^\s*$/)) {
        Toast("请输入昵称");
        return;
      }
      if (nickname.length < 2 || nickname.length > 16 ) {
        Toast("请输入2-16个中英文字符或数字");
        return;
      }
      if (sex.match(/^\s*$/)) {
        Toast("请选择性别");
        return;
      }
      if(that.userInfo.chknickname){
        if(nickname === that.userInfo.chknickname && sex === that.userInfo.sex){
          // Toast("1111");
          return false;
        }

      } else {

        if(nickname === that.userInfo.nickname && sex === that.userInfo.sex){
          // Toast("1111");
          return false;
        }
        
      }
      
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.isLoading = true;
      this.updateUserInfo({
        nickname,
        sex,
        success: (res) => {
                    
          toastLoading.clear();
          that.isLoading = false;

          if (res.status == 1) {
            Toast("操作成功");
          } else {
            Toast(res.message);
          }
        },
      });

    },

    signatureFrom(){
      let that = this;      
      let signature = this.signature;
      if(signature === that.userInfo.signature){        
        // Toast('当前没有修改');
        that.introductionShow = false;
        return false;
      }
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.isLoading = true;
      this.updateUserInfoSignature({
        signature,
        success: (res) => {                    
          toastLoading.clear();
          that.isLoading = false;
          if (res.status == 1) {
            that.introductionShow = false;
            Toast("操作成功");            
          } else {
            Toast(res.message);
          }
        },
      });
    },

  },
  computed: {
    ...mapState({
      guid: (state) => state.user.guid,
      userInfo: (state) => state.user.userInfo,
      security: (state) => state.user.security,
    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.set-wrap {
  margin-bottom: 0.6rem;
  .set-title {
    font-size: 0.3rem;
    color: #333234;
    line-height: 1rem;
    padding: 0 0.55rem;
    font-weight: bold;
  }
  .set-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    min-height: 0.8rem;
    padding: 0 0.68rem 0 0.55rem;

    .t {
      font-size: 0.3rem;
      color: #333234;
      white-space: nowrap;
      margin-right: 0.2rem;
    }
    .des {
      font-size: 0.3rem;
      color: #5c5c5c;
      display: flex;
      align-items: center;
      height: 100%;
      padding-right: 0.3rem;
      position: relative;
      .text {
        word-break: break-all;
        padding: 0.1rem 0;
        // flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 4.6rem;
      }
      input {
        height: 100%;
        text-align: right;
        background: none;
      }
      span.icon {
        width: 0.12rem;
        height: 0.24rem;
        background: url(../../../assets/images/user/set/right.png) no-repeat
          center;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.12rem;
      }
      .sex {
        padding-left: 0.5rem;
        background-position: left center;
        background-repeat: no-repeat;
        background-image: url(../../../assets/images/user/set/ic1.png);
        background-size: auto 0.33rem;
        margin-left: 0.6rem;
        &.active {
          background-image: url(../../../assets/images/user/set/ic1-on.png);
        }
      }
    }
  }
  .set-ts {
    position: absolute;
    right:0.68rem;
    font-size: 0.24rem;
    color: red;
    text-align: right;
  }

  .set-img {
    padding: 0 1.1rem;
    .img-box {
      position: relative;
      width: 1.41rem;
      height: 1.41rem;
      border: 0.02rem solid #7f7f7f;
      background-color: #c8c8c8;
    }
    .img,
    .noImg {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      width: 1.41rem;
      height: 1.41rem;
    }
    .noImg {
      background-image: url(../../../assets/images/user/set/upload.jpg);
      background-size: 0.75rem;
    }
  }
}

.introduction-wrap {
  .in-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.45rem;
    font-size: 0.26rem;
    color: #000;
    line-height: 1.2;
    .red {
      color: #ff0000;
    }
  }
  .in-content {
    padding-top: 0.4rem;
  }
}

.set-btn {
  margin-top: 1.65rem;
}
.set-btn2 {
  margin-top: 1.65rem;
}
</style>

